export default class Refresh extends CustomEvent {
    /** An element Refresh event */
    constructor(caller) {
        super('refresh', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
